<mat-label class="title d-block mt-0 mt-md-5 mb-4">{{ 'claimRegistering.title' | translate }}</mat-label>
<div class="row" *ngIf="!finish">
	<div class="col-12 ps-0">
		<ngb-alert *ngIf="claimId && !existNonPayment && !claimNotConsolidated" type="success" class="d-flex flex-column" [dismissible]="false">
			<div class="alert-title d-flex align-items-center">
				<i class="hs-icon-ok"></i>
				<p class="title m-0 ms-2">{{ 'claimRegistering.registerSuccess' | translate }}</p>
			</div>
			<div class="alert-content">
				<p class="fw-medium m-0 mt-3 mt-md-0">{{ 'claimRegistering.claimNumber' | translate }}</p>
				<p class="fs-6">{{ claimId }}</p>
				<div *ngIf="confirmClaimData.sendFixer">
					<!-- <p class="fw-medium m-0" *ngIf="dateData !== ''">Día y hora primera visita</p> -->
					<p class="fs-6" *ngIf="confirmClaimData.radioDateProfessional">
						{{ 'claimRegistering.professionalArrival' | translate }} {{ dateData }}
						{{ 'claimRegistering.atHour' | translate }} {{ hourData }}.
					</p>
					<!-- <p class="fs-6">Miércoles {{ dateData }} entre las {{ hourData }}.</p> -->
					<p class="fs-6" *ngIf="!confirmClaimData.radioDateProfessional">
						{{ 'claimRegistering.weContactYou' | translate }}
					</p>
				</div>
				<div *ngIf="(confirmClaimData.sendFixer && confirmClaimData.isExistsRepair) || !confirmClaimData.sendFixer">
					<p class="fs-6">
						{{ 'claimRegistering.sendInstructions' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Ok'" class="fs-6 fw-medium text-green">
						{{ 'claimRegistering.sendSuccessful' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Error'  && !failMessage" class="fs-6 fw-medium text-red">
						{{ 'claimRegistering.sendFail' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Error'  && failMessage" class="fs-6 fw-medium text-red">
						{{ failMessage }}
					</p>
					<p *ngIf="getListDocsState() === 'Partial'" class="fs-6 fw-medium text-orange">
						{{ 'claimRegistering.sendPartial' | translate }}
					</p>
					<p *ngIf="isAnyDocPending()" class="fs-6 fw-medium text-grey">
						{{ 'claimRegistering.pendingDocs' | translate }}
					</p>
				</div>
				<p class="fs-6">{{ 'common.thanks' | translate }}.</p>
			</div>
		</ngb-alert>

		<ngb-alert *ngIf="!claimId && !claimNotConsolidated" type="dark" class="d-flex flex-column" [dismissible]="false">
			<div class="alert-title d-flex align-items-center">
				<i class="hs-icon-alert"></i>
				<p class="title m-0 ms-2">
					{{ 'claimRegistering.takeIntoAccount' | translate }}
				</p>
			</div>
			<div class="alert-content">
				<div *ngIf="(confirmClaimData.sendFixer && confirmClaimData.isExistsRepair) || !confirmClaimData.sendFixer">
					<p class="fs-6">
						{{ 'claimRegistering.sendInstructions' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Ok'" class="fs-6 fw-medium text-green">
						{{ 'claimRegistering.sendSuccessful' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Error'" class="fs-6 fw-medium text-red">
						{{ 'claimRegistering.sendFail' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Error'  && failMessage" class="fs-6 fw-medium text-red">
						{{ failMessage }}
					</p>
					<p *ngIf="getListDocsState() === 'Partial'" class="fs-6 fw-medium text-orange">
						{{ 'claimRegistering.sendPartial' | translate }}
					</p>
					<p *ngIf="isAnyDocPending()" class="fs-6 fw-medium text-grey">
						{{ 'claimRegistering.pendingDocs' | translate }}
					</p>
				</div>
				<p class="fs-6">{{ 'common.thanks' | translate }}.</p>
			</div>
		</ngb-alert>

		<ngb-alert *ngIf="existNonPayment" type="danger" class="d-flex flex-column" [dismissible]="false">
			<div class="alert-title d-flex align-items-center">
				<i class="hs-icon-alert"></i>
				<p class="title m-0 ms-2">{{'claimRegistering.registerIssue' | translate}}</p>
			</div>
			<div class="alert-content">
				<p class="fw-medium m-0 mt-3 mt-md-0">{{ 'claimRegistering.claimNumber' | translate }}</p>
				<p class="fs-6">{{ claimId }}</p>
				<p class="fs-6">
					{{'claimRegistering.nonPaymentMsg' | translate}}
				</p>
				<p class="fs-6">
					{{'claimRegistering.sendInstructions' | translate}}
				</p>
				<p class="fs-6">{{ 'common.thanks' | translate }}.</p>
			</div>
		</ngb-alert>

		<ngb-alert *ngIf="claimNotConsolidated" type="dark" class="d-flex flex-column" [dismissible]="false">
			<div class="alert-title d-flex align-items-center">
				<i class="hs-icon-alert"></i>
				<!-- <p class="title m-0 ms-2">{{'claimRegistering.registerIssue' | translate}}</p> -->
				<p class="title m-0 ms-2">
					{{ 'claimRegistering.takeIntoAccount' | translate }}
				</p>
			</div>
			<div class="alert-content">
				<div *ngIf="(confirmClaimData.sendFixer && confirmClaimData.isExistsRepair) || !confirmClaimData.sendFixer">
					<p class="fs-6">
						{{ 'claimRegistering.sendInstructions' | translate }}
						
					</p>
					<p *ngIf="getListDocsState() === 'Ok'" class="fs-6 fw-medium text-green">
						{{ 'claimRegistering.sendSuccessful' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Error'" class="fs-6 fw-medium text-red">
						{{ 'claimRegistering.sendFail' | translate }}
					</p>
					<p *ngIf="getListDocsState() === 'Error'  && failMessage" class="fs-6 fw-medium text-red">
						{{ failMessage }}
					</p>
					<p *ngIf="getListDocsState() === 'Partial'" class="fs-6 fw-medium text-orange">
						{{ 'claimRegistering.sendPartial' | translate }}
					</p>
					<p *ngIf="isAnyDocPending()" class="fs-6 fw-medium text-grey">
						{{ 'claimRegistering.pendingDocs' | translate }}
					</p>
				</div>
				<p class="fs-6">{{ 'common.thanks' | translate }}.</p>
			</div>
		</ngb-alert>

		<div *ngIf="(confirmClaimData.sendFixer && confirmClaimData.isExistsRepair) || !confirmClaimData.sendFixer">
			<p class="mt-5" [innerHTML]="'claimRegistering.attachDocuments' | translate"></p>
			<p class="subtitle">{{ 'claimRegistering.requiredDocs' | translate }}</p>
			<!-- <validation-messages [control]="formGroup.get('documentList')"></validation-messages> -->
			<span *ngIf="maxDocumentSizeReached" class="text-danger">
				{{ 'claimRegistering.invalidDocSize' | translate }}
			</span>
			<span *ngIf="typeFileNotAccept" class="text-danger">
				{{ 'claimRegistering.typeFileNotAccept' | translate }}
			</span>
			<div class="file-upload mb-3" *ngFor="let doc of docs" [ngClass]="doc.files.length > 0 ? ' active' : ''">
				<div class="file-upload-head">
					<div class="file-upload-head-content-text">
						<p class="fw-medium mb-2">{{ 'docs.'+doc.id | translate }}</p>
					</div>
					<input
						class="form-control"
						type="file"
						id="formFileMultiple"
						multiple
						accept="{{ acceptedFileType }}"
						(change)="updateDocumentList($event, doc.id)"
						onclick="this.value=null"
					/>
				</div>
				<div class="file-upload-content" *ngIf="doc.files.length > 0">
					<ul class="list" *ngFor="let file of doc.files">
						<li>
							<div class="content-data">
								<div *ngIf="file.state === 'Pending' || !file.state" class="file-upload-head-container-icon">
									<i class="ico hs-icon-doc icon icon-pending"></i>
								</div>
								<div *ngIf="file.state === 'Sent'" class="file-upload-head-container-icon">
									<i class="ico hs-icon-check"></i>
									<i class="ico hs-icon-doc icon icon-sucess"></i>
								</div>
								<div *ngIf="file.state === 'Fail'" class="file-upload-head-container-icon">
									<i class="ico hs-icon-cross cross-white"></i>
									<i class="ico hs-icon-doc icon icon-fail"></i>
								</div>
								<div>
									<span>{{ file.name }}</span>
								</div>
								<div>
									<div *ngIf="file.state === 'Pending' || file.state === 'Fail' || !file.state">
										<i class="hs-icon-delete" style="cursor: pointer" (click)="deleteDocFile(file.name, doc.id)"></i>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="row" *ngIf="(confirmClaimData.sendFixer && confirmClaimData.isExistsRepair) || !confirmClaimData.sendFixer && !finish">
	<div class="col-12 mt-4 c-alert--green" *ngIf="getListDocsState() === 'Ok'">
		<i class="hs-icon-check fs-2 text-green"></i>
		<div>
			<span class="fs-5 fw-medium text-green">{{ 'claimRegistering.sendSuccessful' | translate }}</span>
			<p>{{ 'claimRegistering.thanksForSend' | translate }}</p>
		</div>
	</div>
	<div class="col-12 mt-4 c-alert--red" *ngIf="getListDocsState() === 'Error'">
		<i class="hs-icon-alert fs-2 text-red"></i>
		<div>
			<span class="fs-5 fw-medium text-red">{{ 'claimRegistering.sendFail' | translate }}</span>
		</div>
	</div>
	<div class="col-12 mt-4 c-alert--orange" *ngIf="getListDocsState() === 'Partial'">
		<i class="hs-icon-alert fs-2 text-orange"></i>
		<div>
			<span class="fs-5 fw-medium text-orange">{{ 'claimRegistering.sendPartial' | translate }}</span>
		</div>
	</div>
	<div class="col-12 mt-4 c-alert--grey" *ngIf="isAnyDocPending()">
		<i class="hs-icon-alert fs-2 text-grey"></i>
		<div>
			<span class="fs-5 fw-medium text-grey">{{ 'claimRegistering.pendingDocs' | translate }}</span>
		</div>
	</div>
	<div>
		<p class="mt-5" [innerHTML]="'claimRegistering.reminderPendingDocumentation' | translate"></p>
	</div>
	<div class="col-6 ps-0 mt-4 d-flex justify-content-around">
		<button
			(click)="callSendDocuments()"
			type="button"
			class="btn btn-primary d-flex align-items-center justify-content-center finish-btn"
			[disabled]="!isListDocsFilesExist() || (!isAnyDocFail() && !isAnyDocPending())"
		>
			<i class="icon hs-icon-check text-white"></i>
			{{ 'common.send' | translate }}
		</button>
	</div>
	<div class="col-6 ps-0 mt-4 d-flex justify-content-around">
		<button
			(click)="finishAndBye()"
			type="button"
			class="btn btn-primary d-flex align-items-center justify-content-center finish-btn"
		>
			<i class="icon hs-icon-check text-white"></i>
			{{ 'common.finish' | translate }}
		</button>
	</div>
</div>

<div class="row" *ngIf="!((confirmClaimData.sendFixer && confirmClaimData.isExistsRepair) || !confirmClaimData.sendFixer && !finish)">
	<div class="col-12 ps-0 mt-4 d-flex justify-content-around">
		<button
			(click)="finishAndBye()"
			type="button"
			class="btn btn-primary d-flex align-items-center justify-content-center finish-btn"
		>
			<i class="icon hs-icon-check text-white"></i>
			{{ 'common.finish' | translate }}
		</button>
	</div>
</div>

<div class="c-finish--green" *ngIf="finish">
	<div class="child-finish">
		<i class="hs-icon-check text-green iconMargin"></i>
		<div>
			<span class="fs-5 fw-medium text-green">{{ 'claimRegistering.thanksForUse' | translate }}</span>
			<p>{{ 'claimRegistering.closeWindow' | translate }}</p>
		</div>
	</div>
</div>
